import { getUpdatedValue } from "../../../../features/Assistants/helpers/getUpdatedValue";
import { getSpaUpdatedValue } from "../../../../features/Editor/helpers/getSpaUpdatedValue";
import { AssistantValue } from "../../../../services/api/instances/assistantsApi/types";
import { EditorValue } from "../../../../services/api/instances/editorApi/types";
import {
  StorageObjectValue,
  StorageScope,
} from "../../../../services/api/instances/storageApi/types/service_types";
import {
  isServiceAssistantValue,
  isServiceSpaValue,
} from "./storageServiciesTypeGuards";

type CopyStrategy = (originalValue: StorageObjectValue) => StorageObjectValue;

export type CopyStorageScope = "assistants" | "ai_agents_spa";

export const copyStorageObjectStrategies: Record<
  CopyStorageScope,
  CopyStrategy
> = {
  assistants: (originalValue) => {
    if (!isServiceAssistantValue) {
      return originalValue;
    }
    return getUpdatedValue(originalValue as AssistantValue, {
      thread_id: "",
    });
  },
  ai_agents_spa: (originalValue) => {
    if (!isServiceSpaValue) {
      return originalValue;
    }
    return getSpaUpdatedValue(originalValue as EditorValue, {
      thread_id: undefined,
    });
  },
};

export const defaultCopyStrategy: CopyStrategy = (value) => value;
